export default "__VITE_ASSET__BAPRkDTO__"